import React from 'react';
import { Outlet } from 'react-router-dom';
import { Navigation } from '../organisms/Navigation';
import { MigrationModal } from '../organisms/MigrationModal';

export const BaseLayout: React.FC = () => {
  return (
    <div className="min-h-screen bg-gray-50 dark:bg-gray-900">
      <Navigation />
      <MigrationModal />
      <Outlet />
    </div>
  );
};
